import React from "react";
import "./VdictDictionaryComponent.css";
function VdictDictionaryComponent() {
    return (
        <h2 className={"title"}>Vdict Dictionary</h2>
    )
}
export default VdictDictionaryComponent
